import { config } from "../config/environment";
import axios from "axios";

export const getToken = async () => {

    let obj = {
        result: false,
        token: '',
        message: '',
    };

    try {
        await axios({
            url: config.tokenService,
            method: "post",
            data: { dominio: config.movistarDominio }
        })
            .then((data) => {
                if (data.status === 200) {
                    obj.result = true;
                    obj.token = data.data.data.token;
                    sessionStorage.setItem('token', obj.token)
                    obj.message = "Token generado con éxito";
                } else {
                    obj.result = false;
                    obj.token = '';
                    obj.message = "Token no generado.";
                }
            })
            .catch((e) => {
                obj.result = false;
                obj.token = '';
                obj.message = "Error generando token.";
            })
    } catch (e) {
        obj.result = false;
        obj.token = '';
        obj.message = "Error intentando generar token.";
    }

    return obj;
}

export async function getGeoIp() {
    try {
        const response = await axios.get(config.geoIpService);
        return response.data;
    } catch (error) {
        console.error(error);
    }
}

export async function getSessionId(data) {
    try {
        const response = await axios({
            url: config.sessionIdService,
            method: "POST",
            data,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        })

        if (!response.data.success) {
            console.error(response.data.message);
            throw new Error(response.data.message);
        }

        return response.data;
    } catch (error) {
        console.error(error);
    }
}